// extracted by mini-css-extract-plugin
export var arrows = "_o-6";
export var decrementer = "_o-a";
export var disabled = "_o-4";
export var error = "_o-1";
export var hiddenText = "_o-b";
export var incrementer = "_o-9";
export var input = "_o-8";
export var inputWrapper = "_o-0";
export var leadingIcon = "_o-c";
export var readonly = "_o-3";
export var regular = "_o-7";
export var small = "_o-5";
export var warning = "_o-2";